<template>
  <div v-if="$template" class="w-full !text-grey header-title">
    <!--Version desktop-->
    <div class="hidden lg:flex justify-between w-full pt-4 px-4">
      <div>
        <img :src="imgUrl($template.logo, 'campaign_logo')" alt="" class="w-40 max-h-40 mb-2"
          style="object-fit: scale-down" />
      </div>
      <div class="text-right h-fit my-auto" :style="'color:' + $template.header_text_color">
        <div class="md:flex w-full flex-row justify-end whitespace-nowrap text-xs">
          <p>Jeu soumis à aléas et à tirage au sort par Commissaire de Justice <span class="inline">-</span></p>
          <div class="link ml-1" @click="
            openModal(
              'Règlement Officiel de Jeu – Attribution soumise à aléas – À lire avec attention',
              $template.rules
            )
            ">
            voir le règlement de jeu
          </div>
        </div>
        <div class="flex flex-row flex-wrap w-full whitespace-nowrap justify-end uppercase text-sm">
          <div class="flex justify-center flex-wrap">
            <div class="cursor-pointer" @click="
              openModal(
                'Mentions légales',
                $template.legal_notice,
                $template.legal_notice_picture
              )
              ">
              Mentions légales
            </div>
            <p class="mx-1 block">|</p>
            <div class="cursor-pointer" @click="
              openModal(
                'Données personnelles et Cookies',
                $template.personal_data,
                $template.personal_data_picture
              )
              ">
              Données personnelles et cookies
            </div>
            <p class="mx-1 block">|</p>
          </div>

          <div class="flex justify-center flex-wrap">
            <div class="cursor-pointer" @click="
              openModal(
                'Règlement Officiel de Jeu – Attribution soumise à aléas – À lire avec attention',
                $template.rules,
                $template.rules_picture
              )
              ">
              Règlement de jeu
            </div>
            <p class="mx-1 block">|</p>
            <div class="cursor-pointer" @click="
              openModal(
                'Conditions Générales de Vente',
                $template.conditions,
                $template.conditions_picture
              )
              ">
              Conditions générales de vente
            </div>
            <p class="mx-1 block">|</p>
            <div class="cursor-pointer" @click="
              openModal(
                'Contact',
                $template.contact,
                $template.contact_picture
              )
              ">
              Contact
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Version mobile-->
    <div class="block lg:hidden mb-2">
      <div class="flex justify-between w-full pt-4 px-4">
        <div>
          <img :src="imgUrl($template.logo, 'campaign_logo')" alt="" class="m-auto w-40 max-h-40 mb-2"
            style="object-fit: scale-down" />
        </div>
        <div class="text-center h-fit my-auto" :style="'color:' + $template.header_text_color">
          <div class="flex flex-col flex-wrap w-full whitespace-nowrap justify-center uppercase text-[10px] mt-1">
            <div class="flex justify-end flex-wrap">
              <div class="cursor-pointer" @click="
                openModal(
                  'Mentions légales',
                  $template.legal_notice,
                  $template.legal_notice_picture
                )
                ">
                Mentions légales
              </div>
              <p class="mx-1">|</p>
              <div class="cursor-pointer" @click="
                openModal(
                  'Données personnelles et Cookies',
                  $template.personal_data,
                  $template.personal_data_picture
                )
                ">
                Données personnelles et cookies
              </div>
              <p class="mx-1">|</p>
            </div>

            <div class="flex justify-end flex-wrap">
              <div class="cursor-pointer" @click="
                openModal(
                  'Règlement Officiel de Jeu – Attribution soumise à aléas – À lire avec attention',
                  $template.rules,
                  $template.rules_picture
                )
                ">
                Règlement de jeu
              </div>
              <p class="mx-1 block">|</p>
              <div class="cursor-pointer" @click="
                openModal(
                  'Conditions Générales de Vente',
                  $template.conditions,
                  $template.conditions_picture
                )
                ">
                CGV
              </div>
              <p class="mx-1">|</p>
              <div class="cursor-pointer" @click="
                openModal(
                  'Contact',
                  $template.contact,
                  $template.contact_picture
                )
                ">
                Contact
              </div>
              <p class="mx-1">|</p>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full whitespace-nowrap text-xs mt-2">
        <p class="text-center">Jeu soumis à aléas et à tirage au sort par Commissaire de Justice</p>
        <div class="link ml-1 text-center" @click="
          openModal(
            'Règlement Officiel de Jeu – Attribution soumise à aléas – À lire avec attention',
            $template.rules
          )
          ">
          voir le règlement de jeu
        </div>
      </div>
    </div>

    <!-- cas spécial si page landing ou scratch et si option désactivé on a pas ces images -->
    <div v-if="
      (currentRouteName === 'landing' && !$template.disabled_campaign_title_picture_landing) ||
      (currentRouteName === 'acquisition' && $template.campaign_template_mechanic_id !== 3 && $template.campaign_template_mechanic_id !== 4 && $template.campaign_template_mechanic_id !== 5) ||
      currentRouteName !== 'landing' && currentRouteName !== 'acquisition'
    ">
      <!-- img mobile -->
      <div v-if="!$template.disabled_campaign_title_picture_mobile && $template.campaign_title_picture_mobile"
        class="block lg:hidden mt-4 lg:mt-0">
        <img :src="imgUrl(isWinner && $template.campaign_title_picture_mobile_win ? $template.campaign_title_picture_mobile_win : $template.campaign_title_picture_mobile, 'campaign_personnalisation')
          " alt="" class="w-full m-auto" />
      </div>
      <!-- img desktop -->
      <div v-if="!$template.disabled_campaign_title_picture" class="hidden lg:block mt-4 lg:mt-0">
        <img :src="imgUrl(isWinner && $template.campaign_title_picture_win ? $template.campaign_title_picture_win : $template.campaign_title_picture, 'campaign_personnalisation')
          " alt="" class="w-full m-auto" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['openModal'],
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    isWinner() {
      return this.$store.isWheelWinner && this.$template.campaign_template_mechanic_id === 5
    }
  },
  methods: {
    openModal(title, message, img) {
      this.$emit('openModal', title, message, img)
    }
  }
}
</script>

<style scoped>
.title {
  background-color: v-bind("$template && !$template.disabled_campaign_title ? $template.campaign_title_background_color : ''"
    );
}

.header-title {
  background-color: v-bind("$template && $template.page_background_color ? $template.page_background_color : ''"
    );
}
</style>
